import React, { useState } from 'react';
import { Box, Typography, Button, Collapse } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AppError } from '../../../context/appConfigurationContext/appConfigurationContext.types';
import './ErrorPage.scss';

interface ErrorPageProps {
  error?: AppError;
  title: string;
  description: string;
}

const defaultProps = {
  title: 'Error loading booking data',
  description: 'Something went wrong',
  error: undefined,
} as const;

export const ErrorPage: React.FC<Partial<ErrorPageProps>> = ({
  error,
  title = defaultProps.title,
  description = defaultProps.description,
}) => {
  const [isStackTraceVisible, setIsStackTraceVisible] = useState(false);

  const toggleStackTrace = (): void => {
    setIsStackTraceVisible(!isStackTraceVisible);
  };

  return (
    <Box className="error-page">
      <Box className="error-page__content">
        <ErrorOutlineIcon className="error-page__icon" color="error" />
        <Typography variant="h5" component="h1" className="error-page__title">
          {error?.error || title}
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          className="error-page__description"
        >
          {error?.description || description}
        </Typography>

        {error?.traceStack && (
          <Box className="error-page__stack-trace-container">
            <Button
              onClick={toggleStackTrace}
              endIcon={
                isStackTraceVisible ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              className="error-page__stack-trace-button"
            >
              {isStackTraceVisible ? 'Hide Details' : 'Show Details'}
            </Button>
            <Collapse in={isStackTraceVisible}>
              <Box className="error-page__stack-trace">
                <pre>
                  <code>{error.traceStack.stack}</code>
                </pre>
              </Box>
            </Collapse>
          </Box>
        )}
      </Box>
    </Box>
  );
};

ErrorPage.defaultProps = defaultProps;

export default ErrorPage;
